import Sidebar from './Sidebar'
import Header from "./Header";
import Footer from "./Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {useState, useEffect, useContext, ChangeEvent} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "./Url";
import {useSelector} from "react-redux";
import {AesEncrypt, reissue} from "./UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";
import passwordValid from "./passwordValid";
import { MESSAGES } from '../utill/Messages';

function PasswordChange(){
    const url = useContext(Url)
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.value);
    const [passwd, setPasswd] = useState('');
    const [passwdCheck, setPasswdCheck] = useState('');
    const [error, setError] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [message, setMessage] = useState({text: '', color: ''});
    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-사용자 정보 수정'
    })

    const handlePasswdChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPasswd(value);

        if (value === '') {
            setError('');
        } else {
            if (passwordValid(value)) {
                setError('');
                setDisabled(false);
            } else {
                setError(MESSAGES.PASSWORD.INVALID);
                setDisabled(false);
            }
        }
    };

    const handlePasswdCheckChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPasswdCheck(e.target.value);
    };

    useEffect(() => {
        if ((passwd !== passwdCheck) || !passwordValid(passwd)) {
            setMessage({text: MESSAGES.PASSWORD.MISMATCH, color: "red"});
            setDisabled(true);
        } else if (passwd === passwdCheck) {
            setMessage({text: MESSAGES.PASSWORD.CORRECT, color: "green"});
            setDisabled(false);
        }
        if (!passwd && !passwdCheck) {
            setMessage({text: '', color: ''});
            setDisabled(true);
        }
    }, [passwd, passwdCheck]);

    const handleUpdateUser = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Update = window.confirm(`비밀번호를 수정하시겠습니까?`)
            if (Update) {
                axios.put(url + `admin/update/password`, {
                    userId: userId,
                    password: AesEncrypt(passwd),
                    loginId:userId
                }, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    }
                })
                    .then(res => {
                        alert('수정 완료되었습니다.');
                        navigate(-1);
                    })
                    .catch(error => {
                        console.log(error);
                        alert('비밀번호 수정에 실패하였습니다.');
                    });
            } else {
                console.log(e);
            }
        })
    }

    const handleModifyCancel = () => {
        reissue(userId, url, navigate).then(() => {
            const Cancel = window.confirm('취소하시겠습니까? 수정중인 내용이 모두 삭제됩니다.');
            if (Cancel) {
                navigate(-1);
            }
        })
    }

    return (
        <div id="wrapper">
            <Sidebar menuCode={''}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='비밀번호 변경'/>
                        <Card className="card shadow mb-4">
                                <Card.Body style={{margin:'1rem'}}>
                                    <Table bordered>
                                        <tbody>
                                        <tr>
                                            <td style={{width:"20%", height:"2rem", verticalAlign: "middle"}} className={styles.tableHead}><p>아이디</p></td>
                                            <td style={{width:"80%", verticalAlign:"middle", color:"black"}}><p>{userId}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>비밀번호</p></td>
                                            <td style={{width:"80%"}}>
                                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <Form.Control
                                                            type="password"
                                                            placeholder="비밀번호"
                                                            name="password"
                                                            value={passwd}
                                                            onChange={handlePasswdChange}
                                                        />
                                                        {error && <p style={{ marginTop: '4px' }}>{error}</p>}
                                                    </div>
                                                    <p style={{ marginLeft: '1rem', marginTop: '10px' }}>
                                                        {MESSAGES.PASSWORD.FORMAT}
                                                    </p>
                                                </div></td>
                                        </tr>
                                        <tr>
                                            <td style={{width:"20%"}} className={styles.tableHead}><p>비밀번호 확인</p></td>
                                            <td style={{width:"80%"}}>
                                                <Form.Control type="password" placeholder="비밀번호 확인" name="passwdCheck"
                                                              value={passwdCheck} onChange={handlePasswdCheckChange}/>
                                            <p style={{margin: '5px 0 0 13px', color: message.color}}>{message.text}</p>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                    <div className="btn modify" style={{float:'right'}}>
                                        <button className="btn btn-primary" disabled={disabled}
                                                onClick={handleUpdateUser}>수정
                                        </button>
                                        <button className="btn btn-secondary" onClick={handleModifyCancel}>취소</button>
                                    </div>
                                </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}
export default PasswordChange;